import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JobService } from './job.service';
import { Job } from '@contracts/interfaces/job.interface';
import { MatDialog } from '@angular/material/dialog';
import { PayPayrollDialogComponent } from '../dialogs/payroll-pay/payroll-pay.dialog';
import { Transfer } from '@contracts/interfaces/transaction.interfaces';

@Injectable({
  providedIn: 'root'
})
export class BankService {


    constructor(private http: HttpClient,
                private connectionService: ConnectionService,
                private jobService: JobService,
                public dialog: MatDialog) {}

    getTransactions(accountNumber: string) {
        return this.http.post(this.connectionService.address + "/bank-service/get-transactions", {
            accountNumber
        });
    }

    getAccounts() {
        return this.http.post(this.connectionService.address + "/bank-service/get-accounts", {});
    }

    transfer (transfers: Transfer[]) {
        this.jobService.create({
            job: Job.BANK_TRANSFER,
            date: {
              start: new Date()
            },
            data: {
              transfers
            }
          }).subscribe(r=> {
            
          });
    }

    openPayrollDialog() {
      this.dialog.open(PayPayrollDialogComponent, {
        autoFocus: true,
        width: '900px',
      });
    }
}
